import type { FormItemDefinition, TableColumnConfiguration } from 'types/formItem';

export const DEFAULT_TABLE_COLUMN_CONFIGURATION = {
  columnWidthMode: 'Auto',
  fixedColumnWidth: null,
  relativeColumnWidth: null,
  columnOverflowMode: 'Ellipsis',
} satisfies TableColumnConfiguration;

export const normalizeTableColumnConfiguration = (value: TableColumnConfiguration) => ({
  ...value,
  fixedColumnWidth: value.columnWidthMode === 'Fixed' ? value.fixedColumnWidth : null,
  relativeColumnWidth: value.columnWidthMode === 'Relative' ? value.relativeColumnWidth : null,
});

export const isTableColumnConfigurationValid = (value: TableColumnConfiguration) => {
  if (!['Ellipsis', 'Wrap'].includes(value.columnOverflowMode)) return false;

  switch (value.columnWidthMode) {
    case 'Auto':
      return true;

    case 'Fixed':
      return Number.isInteger(value.fixedColumnWidth) && value.fixedColumnWidth !== null && value.fixedColumnWidth > 0;

    case 'Relative':
      return value.relativeColumnWidth !== null && ['Normal', 'Wider', 'Widest'].includes(value.relativeColumnWidth);

    default:
      return false;
  }
};

export const mapTableColumnDefinition = (definition: FormItemDefinition) => {
  const configuration = definition.tableColumnConfiguration ?? DEFAULT_TABLE_COLUMN_CONFIGURATION;

  if (!isTableColumnConfigurationValid(configuration)) {
    throw new Error('Invalid table column configuration');
  }

  return {
    ...definition,
    tableColumnConfiguration: normalizeTableColumnConfiguration(configuration),
  };
};
